<template>
  <meting-js server="netease" type="playlist" id="7212363954" fixed="true" theme="#25CCF7"></meting-js>
</template>

<script>
export default {
  name: 'MyAPlayer'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/index/MyAPlayer.vue